const mediaItems = [
  {
    title: '2026夏季新番导视：最值得追的10部漫画',
    desc: '从热血战斗到治愈日常，精选本季不容错过的连载佳作，帮你快速找到下一部心头好。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20showcasing%20summer%20manga%20collection%2C%20vibrant%20warm%20coral%20and%20golden%20color%20palette%2C%20Japanese%20comic%20book%20covers%20arranged%20artistically%2C%20soft%20atmospheric%20lighting%2C%20modern%20manga%20aesthetic%2C%20clean%20art%20style%2C%20editorial%20layout%2C%20professional%20illustration&width=800&height=500&seq=media-manga-01&orientation=landscape',
    alt: '2026夏季新番导视 漫画推荐',
    tag: '新番导视',
  },
  {
    title: '漫画分镜的艺术：大师级画面表现力解析',
    desc: '深入赏析顶级漫画家的分镜技巧，学习如何用画面讲故事，提升阅读审美。',
    img: 'https://readdy.ai/api/search-image?query=Manga%20storyboard%20and%20panel%20layout%20artistic%20display%2C%20dynamic%20Japanese%20comic%20page%20composition%2C%20warm%20terracotta%20and%20cream%20tones%2C%20professional%20illustration%20techniques%2C%20creative%20panel%20arrangement%2C%20soft%20ambient%20light%2C%20art%20studio%20vibe&width=800&height=500&seq=media-manga-02&orientation=landscape',
    alt: '漫画分镜艺术解析 画面表现力',
    tag: '创作课堂',
  },
  {
    title: '从纸媒到屏幕：数字漫画阅读体验进化史',
    desc: '回顾漫画阅读方式变迁，看下拉式阅读如何重新定义移动时代的追漫方式。',
    img: 'https://readdy.ai/api/search-image?query=Digital%20manga%20reading%20experience%20on%20smartphone%20and%20tablet%2C%20modern%20minimalist%20design%2C%20warm%20peach%20and%20ivory%20color%20scheme%2C%20Japanese%20comic%20panels%20on%20screen%2C%20cozy%20reading%20environment%2C%20soft%20natural%20lighting%2C%20clean%20tech%20aesthetic&width=800&height=500&seq=media-manga-03&orientation=landscape',
    alt: '数字漫画阅读体验 下拉式阅读',
    tag: '漫谈',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2 text-center">
          精彩视频
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">漫画不止于阅读，更是一种文化体验</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:ring-2 hover:ring-primary-200">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-1"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-black/50 text-white text-[10px] font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-bold text-base text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}